/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as TabelaRouteImport } from './routes/tabela'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PlanosRouteImport } from './routes/planos'
import { Route as MinhaContaRouteImport } from './routes/minha-conta'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FavoritosRouteImport } from './routes/favoritos'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as CatalogoRouteImport } from './routes/catalogo'
import { Route as CancelarRouteImport } from './routes/cancelar'
import { Route as BuscarRouteImport } from './routes/buscar'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AlertasRouteImport } from './routes/alertas'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlindadosIndexRouteImport } from './routes/blindados.index'
import { Route as UpgradeSuccessRouteImport } from './routes/upgrade.success'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlindadosLocationRouteImport } from './routes/blindados.$location'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AlertasAlertIdRouteImport } from './routes/alertas.$alertId'
import { Route as BlindadosModeloSlugRouteImport } from './routes/blindados.modelo.$slug'
import { Route as BlindadosMarcaSlugRouteImport } from './routes/blindados.marca.$slug'
import { Route as BlindadosModeloSlugLocationRouteImport } from './routes/blindados.modelo.$slug.$location'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const TabelaRoute = TabelaRouteImport.update({
  id: '/tabela',
  path: '/tabela',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanosRoute = PlanosRouteImport.update({
  id: '/planos',
  path: '/planos',
  getParentRoute: () => rootRouteImport,
} as any)
const MinhaContaRoute = MinhaContaRouteImport.update({
  id: '/minha-conta',
  path: '/minha-conta',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritosRoute = FavoritosRouteImport.update({
  id: '/favoritos',
  path: '/favoritos',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ContatoRoute = ContatoRouteImport.update({
  id: '/contato',
  path: '/contato',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogoRoute = CatalogoRouteImport.update({
  id: '/catalogo',
  path: '/catalogo',
  getParentRoute: () => rootRouteImport,
} as any)
const CancelarRoute = CancelarRouteImport.update({
  id: '/cancelar',
  path: '/cancelar',
  getParentRoute: () => rootRouteImport,
} as any)
const BuscarRoute = BuscarRouteImport.update({
  id: '/buscar',
  path: '/buscar',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertasRoute = AlertasRouteImport.update({
  id: '/alertas',
  path: '/alertas',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const BlindadosIndexRoute = BlindadosIndexRouteImport.update({
  id: '/blindados/',
  path: '/blindados/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeSuccessRoute = UpgradeSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => UpgradeRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)
const BlindadosLocationRoute = BlindadosLocationRouteImport.update({
  id: '/blindados/$location',
  path: '/blindados/$location',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertasAlertIdRoute = AlertasAlertIdRouteImport.update({
  id: '/$alertId',
  path: '/$alertId',
  getParentRoute: () => AlertasRoute,
} as any)
const BlindadosModeloSlugRoute = BlindadosModeloSlugRouteImport.update({
  id: '/blindados/modelo/$slug',
  path: '/blindados/modelo/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlindadosMarcaSlugRoute = BlindadosMarcaSlugRouteImport.update({
  id: '/blindados/marca/$slug',
  path: '/blindados/marca/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlindadosModeloSlugLocationRoute =
  BlindadosModeloSlugLocationRouteImport.update({
    id: '/$location',
    path: '/$location',
    getParentRoute: () => BlindadosModeloSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alertas': typeof AlertasRouteWithChildren
  '/blog': typeof BlogRouteWithChildren
  '/buscar': typeof BuscarRoute
  '/cancelar': typeof CancelarRoute
  '/catalogo': typeof CatalogoRoute
  '/contato': typeof ContatoRoute
  '/faq': typeof FaqRoute
  '/favoritos': typeof FavoritosRoute
  '/login': typeof LoginRoute
  '/minha-conta': typeof MinhaContaRoute
  '/planos': typeof PlanosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/tabela': typeof TabelaRoute
  '/termos': typeof TermosRoute
  '/upgrade': typeof UpgradeRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/alertas/$alertId': typeof AlertasAlertIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blindados/$location': typeof BlindadosLocationRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/blindados/': typeof BlindadosIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/blindados/marca/$slug': typeof BlindadosMarcaSlugRoute
  '/blindados/modelo/$slug': typeof BlindadosModeloSlugRouteWithChildren
  '/blindados/modelo/$slug/$location': typeof BlindadosModeloSlugLocationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alertas': typeof AlertasRouteWithChildren
  '/buscar': typeof BuscarRoute
  '/cancelar': typeof CancelarRoute
  '/catalogo': typeof CatalogoRoute
  '/contato': typeof ContatoRoute
  '/faq': typeof FaqRoute
  '/favoritos': typeof FavoritosRoute
  '/login': typeof LoginRoute
  '/minha-conta': typeof MinhaContaRoute
  '/planos': typeof PlanosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/tabela': typeof TabelaRoute
  '/termos': typeof TermosRoute
  '/upgrade': typeof UpgradeRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/alertas/$alertId': typeof AlertasAlertIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blindados/$location': typeof BlindadosLocationRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/blindados': typeof BlindadosIndexRoute
  '/blog': typeof BlogIndexRoute
  '/blindados/marca/$slug': typeof BlindadosMarcaSlugRoute
  '/blindados/modelo/$slug': typeof BlindadosModeloSlugRouteWithChildren
  '/blindados/modelo/$slug/$location': typeof BlindadosModeloSlugLocationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alertas': typeof AlertasRouteWithChildren
  '/blog': typeof BlogRouteWithChildren
  '/buscar': typeof BuscarRoute
  '/cancelar': typeof CancelarRoute
  '/catalogo': typeof CatalogoRoute
  '/contato': typeof ContatoRoute
  '/faq': typeof FaqRoute
  '/favoritos': typeof FavoritosRoute
  '/login': typeof LoginRoute
  '/minha-conta': typeof MinhaContaRoute
  '/planos': typeof PlanosRoute
  '/privacidade': typeof PrivacidadeRoute
  '/tabela': typeof TabelaRoute
  '/termos': typeof TermosRoute
  '/upgrade': typeof UpgradeRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/alertas/$alertId': typeof AlertasAlertIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blindados/$location': typeof BlindadosLocationRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/blindados/': typeof BlindadosIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/blindados/marca/$slug': typeof BlindadosMarcaSlugRoute
  '/blindados/modelo/$slug': typeof BlindadosModeloSlugRouteWithChildren
  '/blindados/modelo/$slug/$location': typeof BlindadosModeloSlugLocationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alertas'
    | '/blog'
    | '/buscar'
    | '/cancelar'
    | '/catalogo'
    | '/contato'
    | '/faq'
    | '/favoritos'
    | '/login'
    | '/minha-conta'
    | '/planos'
    | '/privacidade'
    | '/tabela'
    | '/termos'
    | '/upgrade'
    | '/verify-email'
    | '/alertas/$alertId'
    | '/auth/callback'
    | '/blindados/$location'
    | '/blog/$slug'
    | '/upgrade/success'
    | '/blindados/'
    | '/blog/'
    | '/blindados/marca/$slug'
    | '/blindados/modelo/$slug'
    | '/blindados/modelo/$slug/$location'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alertas'
    | '/buscar'
    | '/cancelar'
    | '/catalogo'
    | '/contato'
    | '/faq'
    | '/favoritos'
    | '/login'
    | '/minha-conta'
    | '/planos'
    | '/privacidade'
    | '/tabela'
    | '/termos'
    | '/upgrade'
    | '/verify-email'
    | '/alertas/$alertId'
    | '/auth/callback'
    | '/blindados/$location'
    | '/blog/$slug'
    | '/upgrade/success'
    | '/blindados'
    | '/blog'
    | '/blindados/marca/$slug'
    | '/blindados/modelo/$slug'
    | '/blindados/modelo/$slug/$location'
  id:
    | '__root__'
    | '/'
    | '/alertas'
    | '/blog'
    | '/buscar'
    | '/cancelar'
    | '/catalogo'
    | '/contato'
    | '/faq'
    | '/favoritos'
    | '/login'
    | '/minha-conta'
    | '/planos'
    | '/privacidade'
    | '/tabela'
    | '/termos'
    | '/upgrade'
    | '/verify-email'
    | '/alertas/$alertId'
    | '/auth/callback'
    | '/blindados/$location'
    | '/blog/$slug'
    | '/upgrade/success'
    | '/blindados/'
    | '/blog/'
    | '/blindados/marca/$slug'
    | '/blindados/modelo/$slug'
    | '/blindados/modelo/$slug/$location'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertasRoute: typeof AlertasRouteWithChildren
  BlogRoute: typeof BlogRouteWithChildren
  BuscarRoute: typeof BuscarRoute
  CancelarRoute: typeof CancelarRoute
  CatalogoRoute: typeof CatalogoRoute
  ContatoRoute: typeof ContatoRoute
  FaqRoute: typeof FaqRoute
  FavoritosRoute: typeof FavoritosRoute
  LoginRoute: typeof LoginRoute
  MinhaContaRoute: typeof MinhaContaRoute
  PlanosRoute: typeof PlanosRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  TabelaRoute: typeof TabelaRoute
  TermosRoute: typeof TermosRoute
  UpgradeRoute: typeof UpgradeRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BlindadosLocationRoute: typeof BlindadosLocationRoute
  BlindadosIndexRoute: typeof BlindadosIndexRoute
  BlindadosMarcaSlugRoute: typeof BlindadosMarcaSlugRoute
  BlindadosModeloSlugRoute: typeof BlindadosModeloSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tabela': {
      id: '/tabela'
      path: '/tabela'
      fullPath: '/tabela'
      preLoaderRoute: typeof TabelaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planos': {
      id: '/planos'
      path: '/planos'
      fullPath: '/planos'
      preLoaderRoute: typeof PlanosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/minha-conta': {
      id: '/minha-conta'
      path: '/minha-conta'
      fullPath: '/minha-conta'
      preLoaderRoute: typeof MinhaContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favoritos': {
      id: '/favoritos'
      path: '/favoritos'
      fullPath: '/favoritos'
      preLoaderRoute: typeof FavoritosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contato': {
      id: '/contato'
      path: '/contato'
      fullPath: '/contato'
      preLoaderRoute: typeof ContatoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogo': {
      id: '/catalogo'
      path: '/catalogo'
      fullPath: '/catalogo'
      preLoaderRoute: typeof CatalogoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancelar': {
      id: '/cancelar'
      path: '/cancelar'
      fullPath: '/cancelar'
      preLoaderRoute: typeof CancelarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buscar': {
      id: '/buscar'
      path: '/buscar'
      fullPath: '/buscar'
      preLoaderRoute: typeof BuscarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alertas': {
      id: '/alertas'
      path: '/alertas'
      fullPath: '/alertas'
      preLoaderRoute: typeof AlertasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/blindados/': {
      id: '/blindados/'
      path: '/blindados'
      fullPath: '/blindados/'
      preLoaderRoute: typeof BlindadosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade/success': {
      id: '/upgrade/success'
      path: '/success'
      fullPath: '/upgrade/success'
      preLoaderRoute: typeof UpgradeSuccessRouteImport
      parentRoute: typeof UpgradeRoute
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
    '/blindados/$location': {
      id: '/blindados/$location'
      path: '/blindados/$location'
      fullPath: '/blindados/$location'
      preLoaderRoute: typeof BlindadosLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alertas/$alertId': {
      id: '/alertas/$alertId'
      path: '/$alertId'
      fullPath: '/alertas/$alertId'
      preLoaderRoute: typeof AlertasAlertIdRouteImport
      parentRoute: typeof AlertasRoute
    }
    '/blindados/modelo/$slug': {
      id: '/blindados/modelo/$slug'
      path: '/blindados/modelo/$slug'
      fullPath: '/blindados/modelo/$slug'
      preLoaderRoute: typeof BlindadosModeloSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blindados/marca/$slug': {
      id: '/blindados/marca/$slug'
      path: '/blindados/marca/$slug'
      fullPath: '/blindados/marca/$slug'
      preLoaderRoute: typeof BlindadosMarcaSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blindados/modelo/$slug/$location': {
      id: '/blindados/modelo/$slug/$location'
      path: '/$location'
      fullPath: '/blindados/modelo/$slug/$location'
      preLoaderRoute: typeof BlindadosModeloSlugLocationRouteImport
      parentRoute: typeof BlindadosModeloSlugRoute
    }
  }
}

interface AlertasRouteChildren {
  AlertasAlertIdRoute: typeof AlertasAlertIdRoute
}

const AlertasRouteChildren: AlertasRouteChildren = {
  AlertasAlertIdRoute: AlertasAlertIdRoute,
}

const AlertasRouteWithChildren =
  AlertasRoute._addFileChildren(AlertasRouteChildren)

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface UpgradeRouteChildren {
  UpgradeSuccessRoute: typeof UpgradeSuccessRoute
}

const UpgradeRouteChildren: UpgradeRouteChildren = {
  UpgradeSuccessRoute: UpgradeSuccessRoute,
}

const UpgradeRouteWithChildren =
  UpgradeRoute._addFileChildren(UpgradeRouteChildren)

interface BlindadosModeloSlugRouteChildren {
  BlindadosModeloSlugLocationRoute: typeof BlindadosModeloSlugLocationRoute
}

const BlindadosModeloSlugRouteChildren: BlindadosModeloSlugRouteChildren = {
  BlindadosModeloSlugLocationRoute: BlindadosModeloSlugLocationRoute,
}

const BlindadosModeloSlugRouteWithChildren =
  BlindadosModeloSlugRoute._addFileChildren(BlindadosModeloSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertasRoute: AlertasRouteWithChildren,
  BlogRoute: BlogRouteWithChildren,
  BuscarRoute: BuscarRoute,
  CancelarRoute: CancelarRoute,
  CatalogoRoute: CatalogoRoute,
  ContatoRoute: ContatoRoute,
  FaqRoute: FaqRoute,
  FavoritosRoute: FavoritosRoute,
  LoginRoute: LoginRoute,
  MinhaContaRoute: MinhaContaRoute,
  PlanosRoute: PlanosRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  TabelaRoute: TabelaRoute,
  TermosRoute: TermosRoute,
  UpgradeRoute: UpgradeRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BlindadosLocationRoute: BlindadosLocationRoute,
  BlindadosIndexRoute: BlindadosIndexRoute,
  BlindadosMarcaSlugRoute: BlindadosMarcaSlugRoute,
  BlindadosModeloSlugRoute: BlindadosModeloSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
